export function setDashboardWidgetStorage(widgetId, property, value) {
  let parsedStorage = getLocalStorage('dashboard-widgets-config', {});
  if (widgetId) {
    let widgetData = parsedStorage[widgetId] ?? {};

    if (property) {
      /** view property template: [mapId, centerX, centerY, zoom] */
      if (property === 'view') {
        if (![null, undefined].includes(value) && value.length !== 4) value = widgetData[property] ?? null;
      }

      if ([null, undefined].includes(value)) delete widgetData[property];
      else widgetData[property] = value;
    } else {
      widgetData = {};
    }

    if (!Object.keys(widgetData).length) delete parsedStorage[widgetId];
    else parsedStorage[widgetId] = widgetData;
  }
  const newStorage = Object.keys(parsedStorage).length ? parsedStorage : null;
  setLocalStorageKey('dashboard-widgets-config', newStorage);
}

export function setRelationsSortingStorage(layerId, datasource, defaultSort, sort) {
  let parsedStorage = getLocalStorage('relations-sorting', {});
  if ([defaultSort, null, undefined].includes(sort)) {
    delete parsedStorage?.[layerId]?.[datasource];
    if (!Object.keys(parsedStorage?.[layerId] ?? {}).length) delete parsedStorage?.[layerId];
  } else {
    parsedStorage[layerId] = {
      ...(parsedStorage[layerId] ?? {}),
      [datasource]: sort,
    };
  }
  const newStorage = Object.keys(parsedStorage).length ? parsedStorage : null;
  setLocalStorageKey('relations-sorting', newStorage);
}

export function setLocalStorageKey(name, storage) {
  storage ? localStorage.setItem(name, JSON.stringify(storage)) : localStorage.removeItem(name);
}

export function getLocalStorage(name, fallback = null) {
  const storage = localStorage.getItem(name);
  return storage ? JSON.parse(storage) : fallback;
}
